import * as React from 'react';

interface ITagProps extends React.PropsWithChildren {
	status?: 'neutral' | 'ready' | 'success' | 'warning';
	type?: 'standard' | 'content';
}

export const Tag: React.FC<ITagProps> = ({ status, type, children }) => {
	return <span className={`tag tag--${type || 'standard'} tag--${status || 'neutral'}`} >{children}</span>;
};
